import Swal from 'sweetalert2';
import JwService from './justwash';


export default  {
    async check() {

        var obj;
        // console.log(localStorage.getItem('alertMessage'));
        // if (localStorage.getItem('alertMessage') !== null) {return}
         if (false) {return}

        else {    
              // eslint-disable-next-line no-undef
              await axios({
                method: 'post',
                url: JwService.getAPI()+'/api/method/justwash.OwnerApi.userdata',
                headers: {
                  'Authorization' : 'Token '+localStorage.getItem('accessToken')
                }
               }).then( async (response) => {
                        console.log(response.data.message.message);
                        obj = response.data.message.message;
                        console.log(obj.type);
                        if (obj.type !== '') {
                            if(localStorage.getItem('alertMessage_' + obj.id )!== null){
                                return
                            }else{
                                return  await Swal.fire({
                                    title: obj.title,
                                    html: '<b>' + obj.text + '</b><br><br> ',
                                    icon: obj.icon,
                                    confirmButtonText: obj.confirmButtonText,
                                    width: '600px',
                                    showCloseButton: obj.showCloseButton,
                                    // timer: obj.timer,
                                    // showCancelButton: false,
                                    // showConfirmButton: false,
                                    allowOutsideClick: false,
                                }).then(function (v) {
                                    if (obj.type == 'change_pass') {
                                            window.location = "/#/changepassword2";
                                    } else {
                                        if (v.isConfirmed == true) {
                                            localStorage.setItem('alertMessage_' + obj.id , 'alertMessage');
                                        }
                                    }
                                })
                            }
                        } 
                        
               }).catch(error => {
                console.log(error)
                // this.$router.push('/login')
               });
        }

       
       
    }
}